import React from 'react'
import { Outlet } from 'react-router-dom'

const Drivers = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Drivers